import { isValidHex } from 'utils/colorContrast';

// Defaults (mismos que el theme actual + backend DEFAULT). Fallback si el
// tenant no trajo colores o trajo hex invalidos.
export const DEFAULT_TENANT_COLORS = {
  primary: '#0055b3',
  secondary: '#c5561d',
};

// Deriva { primary, secondary } de cualquier objeto tipo-tenant que traiga
// `primary_color`/`secondary_color` (branding público, fila completa del
// Tenant, etc.). Pura — sin hooks — para poder usarse tanto en componentes
// (useTenantColors) como en flujos imperativos de generación de PDF (envío
// de informes fuera del árbol de React).
export function deriveTenantColors(tenantLike) {
  const primary = isValidHex(tenantLike?.primary_color)
    ? tenantLike.primary_color
    : DEFAULT_TENANT_COLORS.primary;
  const secondary = isValidHex(tenantLike?.secondary_color)
    ? tenantLike.secondary_color
    : DEFAULT_TENANT_COLORS.secondary;
  return { primary, secondary };
}
